/**
 * Calculates linear interpolation between two points
 * @param x1 - Origin x
 * @param y1 - Origin y
 * @param x2 - Destination x
 * @param y2 - Destination y
 * @param x - Input x value to interpolate
 * @returns Interpolated y value
 */
export const calculateSlope = (
  x1: number,
  y1: number,
  x2: number,
  y2: number,
  x: number
): number => {
  const slope = (y2 - y1) / (x2 - x1);
  return y1 + slope * (x - x1);
};
